import { UserType } from '../../enums';

export function getCompanyName(company) {
  if (!company) {
    return '';
  }

  return (company.registeredName ?? company.legalName ?? company.name ?? '').trim();
}

export function getInitialsFromName(name) {
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  if (parts[0]) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return '';
}

export function getWelcomeFirstName(user, isCompany) {
  const firstName = (user?.userDetails?.firstName || user?.firstName || '').trim();
  if (firstName) {
    return firstName;
  }

  if (isCompany) {
    const representative = user?.company?.representativeName?.trim();
    if (representative) {
      return representative.split(/\s+/)[0];
    }
  }

  return user?.email?.split('@')[0] || 'there';
}

export function getProfileDisplayName(user, isCompany) {
  if (isCompany) {
    return getCompanyName(user?.company) || '—';
  }

  const firstName = user?.userDetails?.firstName || user?.firstName;
  const lastName = user?.userDetails?.lastName || user?.lastName;
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  return user?.email || '—';
}

export function getInitials(user, isCompany) {
  if (isCompany) {
    return getInitialsFromName(getCompanyName(user?.company)) || '—';
  }

  const firstName = (user?.userDetails?.firstName || user?.firstName || '').trim();
  const lastName = (user?.userDetails?.lastName || user?.lastName || '').trim();
  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }
  if (firstName) {
    return firstName.slice(0, 2).toUpperCase();
  }

  return '—';
}

export function getCountryCode(user, isCompany) {
  const country = isCompany
    ? user?.company?.registeredAddress?.country || user?.company?.operatingAddress?.country
    : user?.userDetails?.address?.country;

  if (!country) {
    return null;
  }

  const normalized = String(country).trim();
  if (normalized.length === 2) {
    return normalized.toUpperCase();
  }

  return normalized.slice(0, 2).toUpperCase();
}

export function getProfileSubtitle(user, isCompany) {
  const accountType = isCompany ? 'Business' : 'Personal';
  const country = getCountryCode(user, isCompany);
  return country ? `${accountType} · ${country}` : accountType;
}

export function getIsCompanyUser(user) {
  return user?.userType === UserType.Company || Boolean(user?.company?.name);
}
